import {
  ROUTE_CONTRACT_AWARDS_DETAILS,
  ROUTE_CONTRACT_OPPORTUNITIES_DETAILS,
  ROUTE_GRANT_OPPORTUNITIES_DETAILS,
  ROUTE_STATE_LOCAL_AWARDS_DETAILS,
  ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES_DETAILS,
  ROUTE_STATE_LOCAL_FORECASTS_DETAILS,
} from '../../../constants';

export const NOT_INTERESTED_DETAIL_ROUTES = {
  FGO: ROUTE_GRANT_OPPORTUNITIES_DETAILS.path,
  FCO: ROUTE_CONTRACT_OPPORTUNITIES_DETAILS.path,
  NSN: null,
  CA: ROUTE_CONTRACT_AWARDS_DETAILS.path,
  SLCO: ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES_DETAILS.path,
  SLCF: ROUTE_STATE_LOCAL_FORECASTS_DETAILS.path,
  SLCA: ROUTE_STATE_LOCAL_AWARDS_DETAILS.path,
};

export function getNotInterestedDetailLink(item) {
  if (!item?.typeId) return null;

  let id = item.typeId;
  if (item.type === 'CA') id = `${id}?i=${id}`;
  if (item.type === 'SLCA') id = encodeURIComponent(id);

  const route = NOT_INTERESTED_DETAIL_ROUTES[item.type];
  return route ? route.replace(':id', id) : null;
}
